import { connect } from 'react-redux';

import MenuItem from './desktop.menu.menu_item.jsx';

import { getATagProps } from 'zoomforth_codesbane_viewer/lib/app_actions.js';
import { 
  executeMatchedRouteIfSameHashOnMenuItemClick
} from 'zoomforth_codesbane_viewer/lib/backbone_history_utils.js';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

const mapStateToProps = (state, { submenuItem, lastClickedSubmenuItemId, currentSubpage }) => {
  const selected = (
    lastClickedSubmenuItemId &&
    submenuItem.appAction.subpageId === currentSubpage.id &&
    lastClickedSubmenuItemId === submenuItem.id
  );

  const { href, target } = getATagProps(submenuItem.appAction);
  return {
    selected: selected,
    children: submenuItem.title,
    isExternal: false,
    menuItemId: submenuItem.id,
    href,
    target
  };
};

const mapDispatchToProps = (dispatch, { submenuItem }) => ({
  onClick: () => {
    getTracker().handleNavMenuItemClick(submenuItem);
    executeMatchedRouteIfSameHashOnMenuItemClick(submenuItem);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuItem);
